import React, { useContext, useState, useEffect } from "react";
import { TextField, Button } from "@mui/material";
import { ContextData } from "../../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../../BaseURL";
import SoundAlert from "../../../../../../routes/SoundAlert";
import { Putrequest } from "../../../../../../context/AxiosRequest";

function PersonalReference({ formData }) {
  const { UserTokens, ReloadBioForms, setReloadBioForms } = useContext(ContextData);
   
  const [formDatas, setFormDatas] = useState({
    // 1st Referee
    first_ref_first_name:  "",
    first_ref_middle_name:  "",
    first_ref_surname:  "",
    first_ref_relationship:  "",
    first_ref_address:  "",
    first_ref_phone_no_1:  "",
    first_ref_phone_no_2:  "",
    first_ref_email:  "",

    // 2nd Referee
    second_ref_first_name:  "",
    second_ref_middle_name: "",
    second_ref_surname: "",
    second_ref_relationship:  "",
    second_ref_address:  "",
    second_ref_phone_no_1:  "",
    second_ref_phone_no_2:  "",
    second_ref_email:  "",
  });

  const [showSecondReferee, setShowSecondReferee] = useState(false);

  useEffect(() => {
    const hasFirstRefereeData = Object.keys(formDatas).some(
      (key) => key.startsWith("first_ref_") && formDatas[key]?.trim() !== ""
    );
    setShowSecondReferee(hasFirstRefereeData);
  }, [formDatas]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDatas((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateField = (type, value) => {

    if (type.includes("email")) {

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return value.trim() === "" || emailRegex.test(value.trim());

    }

    if (type.includes("phone_no_1") || type.includes("phone_no_2")) {
      return value.trim() === "" || /^\d{1,15}$/.test(value.trim());
    }

 return value.trim() !== "";
  };

  const handleSubmit =async (type) => {


    if (!validateField(type, formDatas[type])) {
         SoundAlert("error");
      if (type.includes("email")) {
        toast.error("Please enter a valid email address.");
      } else if (type.includes("phone_no_")) {
        toast.error("Phone numbers must contain only digits (max 15).");
      } else {
        toast.error("Please fill in this field.");
      }
      return;
    }

       const response = await Putrequest("auth/update_personel_reference",{...formDatas,user_token:UserTokens})
       
                   
                       if(response.status){
    
                        SoundAlert("success")
                        toast.success(response.textStatus)
                        setReloadBioForms(!ReloadBioForms)
    
                          }




  };



  useEffect(()=>{
  
         setFormDatas({
       // 1st Referee
    first_ref_first_name: formData.personal_references.first_ref_first_name || "",
    first_ref_middle_name: formData.personal_references.first_ref_middle_name || "",
    first_ref_surname: formData.personal_references.first_ref_surname || "",
    first_ref_relationship: formData.personal_references.first_ref_relationship || "",
    first_ref_address: formData.personal_references.first_ref_address || "",
    first_ref_phone_no_1: formData.personal_references.first_ref_phone_no_1 || "",
    first_ref_phone_no_2: formData.personal_references.first_ref_phone_no_2 || "",
    first_ref_email: formData.personal_references.first_ref_email || "",

    // 2nd Referee
    second_ref_first_name: formData.personal_references.second_ref_first_name || "",
    second_ref_middle_name: formData.personal_references.second_ref_middle_name || "",
    second_ref_surname: formData.personal_references.second_ref_surname || "",
    second_ref_relationship: formData.personal_references.second_ref_relationship || "",
    second_ref_address: formData.personal_references.second_ref_address || "",
    second_ref_phone_no_1: formData.personal_references.second_ref_phone_no_1 || "",
    second_ref_phone_no_2: formData.personal_references.second_ref_phone_no_2 || "",
    second_ref_email: formData.personal_references.second_ref_email || "",
         })
  
  },[formData])
  





  return (
    <div className="pt-2 pb-4">
      <h3 className="text-lg font-bold pb-2">1st Referee</h3>

      {[
        { label: "First Name", name: "first_ref_first_name" },
        { label: "Middle Name", name: "first_ref_middle_name" },
        { label: "Surname", name: "first_ref_surname" },
        { label: "Relationship with Applicant", name: "first_ref_relationship" },
        { label: "Address", name: "first_ref_address", multiline: true },
        { label: "Phone No. 1", name: "first_ref_phone_no_1" },
        { label: "Phone No. 2", name: "first_ref_phone_no_2" },
        { label: "Email", name: "first_ref_email", type: "email" },
      ].map((field, index) => (
        <TextField
          key={index}
          label={field.label}
          name={field.name}
          type={field.type || "text"}
          value={formDatas[field.name]}
          onChange={handleChange}
          fullWidth
          margin="dense"
          multiline={field.multiline || false}
          rows={field.multiline ? 3 : 1}
          InputProps={{
            endAdornment: (
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => handleSubmit(field.name)}
              >
                Save
              </Button>
            ),
            maxLength:  (field.name === "first_ref_phone_no_1" || field.name === "first_ref_phone_no_2" ) &&  11
          }}
        />
      ))}
{/*   inputProps={{  maxLength:  name === "" && "" 11 }} */}
      {showSecondReferee && (
        <>
          <h3 className="text-lg font-bold pt-6 pb-2">2nd Referee</h3>
          {[
            { label: "First Name", name: "second_ref_first_name" },
            { label: "Middle Name", name: "second_ref_middle_name" },
            { label: "Surname", name: "second_ref_surname" },
            { label: "Relationship with Applicant", name: "second_ref_relationship" },
            { label: "Address", name: "second_ref_address", multiline: true },
            { label: "Phone No. 1", name: "second_ref_phone_no_1" },
            { label: "Phone No. 2", name: "second_ref_phone_no_2" },
            { label: "Email", name: "second_ref_email", type: "email" },
          ].map((field, index) => (
            <TextField
              key={index}
              label={field.label}
              name={field.name}
              type={field.type || "text"}
              value={formDatas[field.name]}
              onChange={handleChange}
              fullWidth
              margin="dense"
              multiline={field.multiline || false}
              rows={field.multiline ? 3 : 1}
               inputProps={{ maxLength: (field.name === "first_ref_phone_no_1" || field.name === "first_ref_phone_no_2" ) &&  11, inputMode:  (field.name === "first_ref_phone_no_1" || field.name === "first_ref_phone_no_2" ) &&  "numeric" , minLength: (field.name === "first_ref_phone_no_1" || field.name === "first_ref_phone_no_2" ) && 11, pattern: (field.name === "first_ref_phone_no_1" || field.name === "first_ref_phone_no_2" ) && "[0-9]{11}"}}
              InputProps={{
                endAdornment: (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => handleSubmit(field.name)}
                  >
                    Save
                  </Button>
                ),
                
              }}
            />
          ))}
        </>
      )}
    </div>
  );
}

export default PersonalReference;
